(function () {
  'use strict';

  const pool       = document.getElementById('pg-card-pool');
  const outer      = document.getElementById('pg-masonry-outer');
  const searchEl   = document.getElementById('pg-search');
  const clearBtn   = document.getElementById('pg-search-clear');
  const savedBtn   = document.getElementById('pg-saved-btn');
  const savedCount = document.getElementById('pg-saved-count');
  const categories = document.getElementById('pg-categories');
  const emptyEl    = document.getElementById('pg-empty');
  const emptyReset = document.getElementById('pg-empty-reset');
  const toast      = document.getElementById('pg-toast');
  const lightbox   = document.getElementById('pg-lightbox');
  if (!pool || !outer) return;

  let savedIds          = new Set(JSON.parse(localStorage.getItem('pg_saved') || '[]'));
  let activeFilter      = 'all';
  let searchQuery       = '';
  let savedFilterActive = false;
  let toastTimer;
  let colCount          = 0;
  let allCards          = [];
  let liveCols          = [];

  /* ── Column count rules ──────────────────────────────────
     mobile  (≤ 600px)  → 2 columns
     tablet  (601–1024px) → 4 columns  (was previously too low)
     desktop (1025–1299px) → 5 columns
     wide    (≥ 1300px)  → 6 columns
  ──────────────────────────────────────────────────────── */
  function getColCount() {
    const w = window.innerWidth;
    if (w >= 1300) return 6;
    if (w >= 1025) return 5;
    if (w >= 601)  return 4;   /* tablet: 4 columns */
    return 2;                  /* mobile: 2 columns */
  }

  function showCols(n) {
    liveCols.forEach((c, i) => {
      c.style.display = i < n ? 'flex' : 'none';
    });
  }

  /* ── Build masonry ── */
  function buildMasonry() {
    const n = getColCount();
    colCount = n;

    /* Reset columns */
    liveCols.forEach(c => { c.innerHTML = ''; });
    showCols(n);

    const visible = allCards.filter(c => !c.classList.contains('pg-card--hidden'));

    if (visible.length === 0) {
      emptyEl.style.display = 'block';
      return;
    }
    emptyEl.style.display = 'none';

    /* Shortest-column distribution */
    const heights = new Array(n).fill(0);
    const outerW  = outer.offsetWidth || window.innerWidth;
    const colW    = (outerW - (n - 1) * 8) / n;

    visible.forEach(card => {
      const minH = Math.min(...heights);
      const idx  = heights.indexOf(minH);
      const clone = card.cloneNode(true);
      liveCols[idx].appendChild(clone);

      const imgW = parseInt(card.dataset.imgW) || 1;
      const imgH = parseInt(card.dataset.imgH) || 1;
      heights[idx] += (imgH / imgW) * colW + 90;
    });

    attachCardEvents();
    initSaveStates();
  }

  /* ── Filter ── */
  function filterCards() {
    allCards.forEach(card => {
      const catOk    = activeFilter === 'all' || card.dataset.category === activeFilter;
      const searchOk = !searchQuery || card.dataset.title.includes(searchQuery.toLowerCase());
      const savedOk  = !savedFilterActive || savedIds.has(card.dataset.id);
      card.classList.toggle('pg-card--hidden', !(catOk && searchOk && savedOk));
    });
    buildMasonry();
  }

  /* ── Pills ── */
  categories.addEventListener('click', e => {
    const pill = e.target.closest('.pg-pill');
    if (!pill) return;
    document.querySelectorAll('.pg-pill').forEach(p => p.classList.remove('pg-pill--active'));
    pill.classList.add('pg-pill--active');
    activeFilter = pill.dataset.filter;
    savedFilterActive = false;
    filterCards();
  });

  /* ── Search ── */
  searchEl.addEventListener('input', () => {
    searchQuery = searchEl.value.trim();
    clearBtn.style.display = searchQuery ? 'flex' : 'none';
    filterCards();
  });
  clearBtn.addEventListener('click', () => {
    searchEl.value = ''; searchQuery = '';
    clearBtn.style.display = 'none';
    filterCards(); searchEl.focus();
  });

  /* ── Empty reset ── */
  emptyReset.addEventListener('click', () => {
    searchEl.value = ''; searchQuery = '';
    clearBtn.style.display = 'none';
    activeFilter = 'all'; savedFilterActive = false;
    document.querySelectorAll('.pg-pill').forEach((p, i) => p.classList.toggle('pg-pill--active', i === 0));
    filterCards();
  });

  /* ── Toast ── */
  function showToast(msg) {
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 2200);
  }

  /* ── Save ── */
  function persistSaved() { localStorage.setItem('pg_saved', JSON.stringify([...savedIds])); }
  function updateSavedUI() {
    const n = savedIds.size;
    savedCount.textContent = n;
    savedCount.style.display = n > 0 ? 'flex' : 'none';
    savedBtn.classList.toggle('has-saves', n > 0);
  }
  function toggleSave(id, btn, e) {
    if (e) e.stopPropagation();
    document.querySelectorAll(`.pg-card__save[data-id="${id}"]`).forEach(b => {
      if (savedIds.has(id)) { b.textContent = 'Save'; b.classList.remove('saved'); }
      else                  { b.textContent = 'Saved'; b.classList.add('saved'); }
    });
    if (savedIds.has(id)) { savedIds.delete(id); showToast('Removed from saved'); }
    else                  { savedIds.add(id);    showToast('Saved!'); }
    persistSaved(); updateSavedUI();
  }
  savedBtn.addEventListener('click', () => {
    if (savedIds.size === 0) { showToast('No saved items yet'); return; }
    savedFilterActive = !savedFilterActive;
    filterCards();
    showToast(savedFilterActive ? 'Showing saved items' : 'Showing all items');
  });

  /* ── Lightbox ── */
  const lbImg      = document.getElementById('pg-lb-img');
  const lbCategory = document.getElementById('pg-lb-category');
  const lbTitle    = document.getElementById('pg-lb-title');
  const lbPrice    = document.getElementById('pg-lb-price');
  const lbCompare  = document.getElementById('pg-lb-compare');
  const lbDesc     = document.getElementById('pg-lb-desc');
  const lbBuy      = document.getElementById('pg-lb-buy');
  const lbCart     = document.getElementById('pg-lb-cart');
  const lbClose    = document.getElementById('pg-lb-close');
  const lbBackdrop = document.getElementById('pg-lb-backdrop');

  function openLightbox(card) {
    const d = card.dataset;
    lbImg.src               = d.img || '';
    lbImg.alt               = card.querySelector('.pg-card__title')?.textContent || '';
    lbCategory.textContent  = (d.colTitle || d.category || '').replace(/-/g, ' ');
    lbTitle.textContent     = card.querySelector('.pg-card__title')?.textContent || '';
    lbPrice.textContent     = d.price || '';
    lbCompare.textContent   = d.sale === 'true' ? d.compare : '';
    lbCompare.style.display = d.sale === 'true' ? 'inline' : 'none';
    lbDesc.textContent      = d.description || '';
    lbBuy.href  = (d.url || '') + '?buy=1';
    lbCart.href = d.url || '';
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => lbClose.focus());
  }
  function closeLightbox() {
    lightbox.classList.remove('is-open');
    setTimeout(() => { document.body.style.overflow = ''; }, 300);
  }
  lbClose.addEventListener('click', closeLightbox);
  lbBackdrop.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
  });

  /* ── Card events on live columns ── */
  function attachCardEvents() {
    /* Re-query after innerHTML replacement */
    liveCols = Array.from(outer.querySelectorAll('.pg-masonry-col'));
    liveCols.forEach(col => {
      const fresh = col.cloneNode(true);
      col.parentNode.replaceChild(fresh, col);
    });
    liveCols = Array.from(outer.querySelectorAll('.pg-masonry-col'));

    liveCols.forEach(col => {
      col.addEventListener('click', e => {
        const saveBtn  = e.target.closest('.pg-card__save');
        const shareBtn = e.target.closest('.pg-card__action-share');
        const shopBtn  = e.target.closest('.pg-card__shop-btn');
        const linkBtn  = e.target.closest('a.pg-card__action-btn');
        const card     = e.target.closest('.pg-card');
        if (!card) return;
        if (saveBtn)              toggleSave(card.dataset.id, saveBtn, e);
        else if (shareBtn) {
          e.stopPropagation();
          const url = shareBtn.dataset.url, title = shareBtn.dataset.title;
          if (navigator.share) navigator.share({ title, url }).catch(() => {});
          else navigator.clipboard?.writeText(url).then(() => showToast('Link copied!'));
        } else if (!shopBtn && !linkBtn) openLightbox(card);
      });
    });
  }

  function initSaveStates() {
    document.querySelectorAll('.pg-masonry-col .pg-card__save').forEach(btn => {
      if (savedIds.has(btn.dataset.id)) { btn.textContent = 'Saved'; btn.classList.add('saved'); }
    });
  }

  /* ── Resize ── */
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (getColCount() !== colCount) buildMasonry();
    }, 150);
  });

  /* ── Init ── */
  allCards  = Array.from(pool.querySelectorAll('.pg-card'));
  liveCols  = Array.from(outer.querySelectorAll('.pg-masonry-col'));
  updateSavedUI();
  buildMasonry();

})();